import { Side } from 'widgets/LineWidget/LineWidget.types';

enum ResizeDirection {
  Left = 'Left',
  Right = 'Right',
  Top = 'Top',
  Bottom = 'Bottom',
}

/**
 * Get side handle direction of the direction of a moveable resize event
 */

const getSideHandle = (moveableDirection: number[]) => {
  if (moveableDirection[0] === -1 && moveableDirection[1] === 0) return ResizeDirection.Left;
  if (moveableDirection[0] === 1 && moveableDirection[1] === 0) return ResizeDirection.Right;
  if (moveableDirection[0] === 0 && moveableDirection[1] === -1) return ResizeDirection.Top;
  if (moveableDirection[0] === 0 && moveableDirection[1] === 1) return ResizeDirection.Bottom;

  return '';
};

/**
 * Check if the moveable drag event is from a side handle
 */
const isSideHandle = (moveableDirection: number[]): boolean => !!getSideHandle(moveableDirection);
/**
 * Check if the moveable drag event is from a corner handle
 */
const isCornerHandle = (moveableDirection: number[]): boolean => !isSideHandle(moveableDirection);

/**
 * Check if the moveable drag event is from a side handle
 * @param moveableDirection
 *
 * @returns {boolean}
 */
const isLeftSideHandle = (moveableDirection: number[]): boolean =>
  moveableDirection[0] === -1 && moveableDirection[1] === 0;

/**
 * Gets the directions facing a given direction.
 *
 * @param {Side} direction - The input direction.
 * @returns {[Side, Side]} Returns an array of two directions facing the input direction.
 */
const getDirectionsFacing = (direction: Side): [Side, Side] => {
  switch (direction) {
    case Side.NORTH:
      return [Side.WEST, Side.EAST];
    case Side.SOUTH:
      return [Side.EAST, Side.WEST];
    case Side.EAST:
      return [Side.NORTH, Side.SOUTH];
    case Side.WEST:
      return [Side.SOUTH, Side.NORTH];
    default:
      return [Side.NORTH, Side.SOUTH];
  }
};

export { isSideHandle, getSideHandle, ResizeDirection, isCornerHandle, getDirectionsFacing, isLeftSideHandle };
